/* eslint-disable no-console */
export const logMessage = (msg: any, component?: string) => {
  if (import.meta.env.VITE_ENVIRONMENT_TAG === 'dev') {
    console.log(msg, component)
  }
}
